/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

const Params = z.strictObject({ organizationId: ZodTypes.Id });

export const GetSsoGroups = {
  id: 'sso-groups.get',
  tag: 'Customer',
  summary: 'Get all known SSO groups of an organization',
  description: '',
  method: 'get',
  flags: { isAuthorized: true },
  route: (params: z.infer<typeof Params>) => `/organization/${params.organizationId}/sso/group`,
  request: { params: Params },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.strictObject({
            groups: z.array(
              z.strictObject({
                groupName: z.string(),
                users: z.array(
                  z.strictObject({
                    id: ZodTypes.Id,
                    firstName: z.string().min(1),
                    lastName: z.string().min(1),
                    email: z.string().email(),
                  }),
                ),
              }),
            ),
          }),
        },
      },
    },
  },
} as const satisfies Endpoint;
